let endpoint:string|undefined = '';
if (process.env.NODE_ENV === 'production' || process.env.REACT_APP_DEV ==='false'){
    endpoint = process.env.REACT_APP_DEPLOY_ENDPOINT
} else {
    endpoint = process.env.REACT_APP_DEV_ENDPOINT    
}
export {endpoint};